import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Campaign } from '@/types/leads';

export function useCampaigns(activeOnly = true) {
  return useQuery({
    queryKey: ['campaigns', activeOnly],
    queryFn: async () => {
      let query = supabase
        .from('campaigns')
        .select(`
          id,
          name,
          lead_source_id,
          external_campaign_id,
          tracking_number,
          is_active,
          metro_id,
          brand_id,
          brands (
            id,
            name
          ),
          lead_sources (
            id,
            name
          ),
          metros (
            id,
            name
          )
        `)
        .order('name');
      
      if (activeOnly) query = query.eq('is_active', true);
      
      const { data, error } = await query;
      if (error) throw error;
      
      return data as (Campaign & { 
        lead_sources?: { id: string; name: string };
        metros?: { id: string; name: string };
        brands?: { id: string; name: string } | null;
      })[];
    },
  });
}
